module.exports = __webpack_public_path__ + "img/mnd.95d59d09.svg";